import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, X } from 'lucide-react';

const MotionDiv = motion.div;

const PrivacyBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isDismissed = localStorage.getItem('linkit_privacy_flex_dismissed');
    if (!isDismissed) {
      const timer = setTimeout(() => setIsVisible(true), 2500); // Appear after 2.5s
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem('linkit_privacy_flex_dismissed', 'true');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <MotionDiv
          initial={{ y: 100, opacity: 0, scale: 0.9 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 100, opacity: 0, scale: 0.9 }}
          className="fixed bottom-3 left-3 right-3 md:bottom-8 md:left-auto md:right-8 md:max-w-md"
          style={{ zIndex: 9999 }}
        >
          <div className="bg-white border border-edge-umber/20 p-4 sm:p-6 shadow-[0_18px_60px_rgba(32,23,18,0.16)] rounded-3xl relative overflow-hidden group">
            {/* Background Accent */}
            <div className="absolute top-0 right-0 -mr-8 -mt-8 w-24 h-24 bg-edge-coral/5 rounded-full blur-2xl group-hover:bg-edge-coral/10 transition-colors" />
            
            <div className="flex gap-3 sm:gap-5 items-start relative z-10">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-indigo-600 text-white flex items-center justify-center shrink-0 rounded-xl shadow-brutalist-amber">
                <ShieldCheck size={20} />
              </div>
              
              <div className="space-y-2 sm:space-y-3 min-w-0">
                <h4 className="font-semibold tracking-tight text-edge-umber text-base sm:text-lg leading-none">
                  Privacy controls <span className="text-edge-coral">active</span>
                </h4>
                <p className="text-xs sm:text-sm font-medium text-edge-umber/60 leading-relaxed">
                  Linkit does not add platform ad trackers by default. Creators may connect their own pixels while essential providers support security, analytics, hosting and email delivery.
                </p>
                
                <div className="flex flex-wrap items-center gap-3 sm:gap-4 pt-1 sm:pt-2">
                  <button
                    onClick={dismiss}
                    className="px-5 sm:px-6 py-2 bg-edge-umber text-white font-semibold text-xs tracking-wide rounded-full hover:bg-edge-pink transition-all active:scale-95 cursor-pointer"
                    style={{ position: 'relative', zIndex: 20 }}
                  >
                    Understood
                  </button>
                  <a
                    href="/cookies"
                    className="text-xs font-semibold tracking-wide text-edge-umber/40 hover:text-edge-pink transition-colors underline decoration-1 underline-offset-4 cursor-pointer"
                    style={{ position: 'relative', zIndex: 20 }}
                  >
                    View policy
                  </a>
                </div>
              </div>

              <button 
                onClick={dismiss}
                className="text-edge-umber/40 hover:text-edge-coral transition-colors p-1 shrink-0 cursor-pointer"
                style={{ position: 'relative', zIndex: 20 }}
                aria-label="Dismiss privacy notice"
              >
                <X size={18} />
              </button>
            </div>
          </div>
        </MotionDiv>
      )}
    </AnimatePresence>
  );

};

export default PrivacyBanner;
